<template>
    <div>
        <header-landing></header-landing>
        <div style="height: 100px; overflow: hidden; margin-top: -80px" ><svg viewBox="0 0 500 150" preserveAspectRatio="none" style="height: 100%; width: 100%;"><path d="M-4.79,11.34 C149.99,150.00 349.20,-49.98 504.79,26.14 L500.00,150.00 L0.00,150.00 Z" style="stroke: none; fill: #EEF3F9;"></path></svg></div>

        <continue-landing></continue-landing>
        <testimonials></testimonials>
        <final-landing></final-landing>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import headerLanding from './header_landing.vue'
    import ContinueLanding from './continue_landing.vue'
    import FinalLanding from './final_landing.vue'
    import Testimonials from './testimonialsComunicacionTM.vue'
    export default {
        metaInfo: {
            title: 'Telemedicina a un click',
            titleTemplate: '%s - Dra Omidres Pérez!',
            content: 'Telemedicina, tememedicina, consulta online, consulta en linea',
            meta: [
                { name: 'Telemedicina, tememedicina, consulta online, consulta en linea',
                    content: 'Telemedicina, tememedicina, consulta online, consulta en linea',
                    description: 'Telemedicina, tememedicina, consulta online, consulta en linea',
                    vmid: 'Hagamos viral la salud con la Dra. Omidres Pérez' }
            ],
            htmlAttrs: {
                lang: 'en',
                amp: true,

            }
        },
        name: 'PonlaEnControl',
        components: {
            headerLanding,
            ContinueLanding,
            FinalLanding,
            Testimonials
        },
        created(){

        },
        data(){
            return {

            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>